/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import httpService from '@/core/http/http.service';
import serverContextStore from '@/shared/content/server-context.store';
import { AxiosRequestConfig } from 'axios';

export class B2CClient {

    create_MyBolia_profile(request: CreateMyBoliaProfileRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/b2c/integration/webhook/mybolia';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponse>(apiUrl, request, messageId);
    }
    specialDeliveryRequest(request: SpecialDeliveryRequest, messageId?: string): Promise<ClientResponseOfSpecialDeliveryResponse> {
        let apiPathAndParams = '/api/b2c/special-delivery-request';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfSpecialDeliveryResponse>(apiUrl, request, messageId);
    }
    getClaimableProductsByOrderNumberRequest(request: GetClaimableProductsByOrderNumberRequest, messageId?: string): Promise<ClaimableProduct[]> {
        let apiPathAndParams = '/api/b2c/publicclaimform/products';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClaimableProduct[]>(apiUrl, request, messageId);
    }
    createPublicClaim(request: CreatePublicClaimsRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/b2c/publicclaimform';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponse>(apiUrl, request, messageId);
    }
    uploadPublicClaimFormFile(file: FileParameter | null | undefined, messageId?: string): Promise<ClientResponseOfPublicUploadClaimFormFileResponse> {
        let apiPathAndParams = '/api/b2c/publicclaimform/upload-file';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfPublicUploadClaimFormFileResponse>(apiUrl, messageId);
    }
    getPersonalOffers(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfPersonalOfferOverviewModelOf> {
        let apiPathAndParams = '/api/b2c/personaloffer';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPersonalOfferOverviewModelOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/personaloffer-' + cancellationContextKey : undefined);
    }
    getPersonalOfferById(offerId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfPersonalOfferViewModel> {
        let apiPathAndParams = '/api/b2c/personaloffer/{offerId}';
        if (offerId === undefined || offerId === null)
            throw new Error('The parameter "offerId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{offerId}', encodeURIComponent('' + offerId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPersonalOfferViewModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/personaloffer/{offerId}-' + cancellationContextKey : undefined);
    }
    subscribeToNewsletter(request: SubscribeToNewsletterRequest, messageId?: string): Promise<ClientResponseOfSubscribeToNewsletterResponse> {
        let apiPathAndParams = '/api/b2c/newsletter';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfSubscribeToNewsletterResponse>(apiUrl, request, messageId);
    }
    getAllWishLists(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfIEnumerableOfWishList> {
        let apiPathAndParams = '/api/b2c/my-bolia/wishlist';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfIEnumerableOfWishList>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/my-bolia/wishlist-' + cancellationContextKey : undefined);
    }
    createWishList(createWishListRequest: CreateWishListRequest, messageId?: string): Promise<ClientResponseOfIEnumerableOfWishList> {
        let apiPathAndParams = '/api/b2c/my-bolia/wishlist';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfIEnumerableOfWishList>(apiUrl, createWishListRequest, messageId);
    }
    getWishList(wishListId: number, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfWishList> {
        let apiPathAndParams = '/api/b2c/my-bolia/wishlist/{wishListId}';
        if (wishListId === undefined || wishListId === null)
            throw new Error('The parameter "wishListId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{wishListId}', encodeURIComponent('' + wishListId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfWishList>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/my-bolia/wishlist/{wishListId}-' + cancellationContextKey : undefined);
    }
    updateWishList(wishListId: number, updateWishListRequest: UpdateWishListRequest, messageId?: string): Promise<ClientResponseOfWishList> {
        let apiPathAndParams = '/api/b2c/my-bolia/wishlist/{wishListId}';
        if (wishListId === undefined || wishListId === null)
            throw new Error('The parameter "wishListId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{wishListId}', encodeURIComponent('' + wishListId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfWishList>(apiUrl, updateWishListRequest, messageId);
    }
    deleteWishList(wishListId: number, messageId?: string): Promise<ClientResponseOfIEnumerableOfWishList> {
        let apiPathAndParams = '/api/b2c/my-bolia/wishlist/{wishListId}';
        if (wishListId === undefined || wishListId === null)
            throw new Error('The parameter "wishListId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{wishListId}', encodeURIComponent('' + wishListId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfIEnumerableOfWishList>(apiUrl, messageId);
    }
    createWishListItem(wishListId: number, createWishListItemRequest: CreateWishListItemRequest, messageId?: string): Promise<ClientResponseOfIEnumerableOfWishList> {
        let apiPathAndParams = '/api/b2c/my-bolia/wishlist/{wishListId}/wishlistitem';
        if (wishListId === undefined || wishListId === null)
            throw new Error('The parameter "wishListId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{wishListId}', encodeURIComponent('' + wishListId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfIEnumerableOfWishList>(apiUrl, createWishListItemRequest, messageId);
    }
    deleteWishListItem(wishListId: number, wishListItemId: number, messageId?: string): Promise<ClientResponseOfWishList> {
        let apiPathAndParams = '/api/b2c/my-bolia/wishlist/{wishListId}/wishlistitem/{wishListItemId}';
        if (wishListId === undefined || wishListId === null)
            throw new Error('The parameter "wishListId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{wishListId}', encodeURIComponent('' + wishListId));
        if (wishListItemId === undefined || wishListItemId === null)
            throw new Error('The parameter "wishListItemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{wishListItemId}', encodeURIComponent('' + wishListItemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfWishList>(apiUrl, messageId);
    }
    getSharedWishList(sharedIdentifier: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfWishList> {
        let apiPathAndParams = '/api/b2c/my-bolia/wishlist/shared/{sharedIdentifier}';
        if (sharedIdentifier === undefined || sharedIdentifier === null)
            throw new Error('The parameter "sharedIdentifier" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sharedIdentifier}', encodeURIComponent('' + sharedIdentifier));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfWishList>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/my-bolia/wishlist/shared/{sharedIdentifier}-' + cancellationContextKey : undefined);
    }
    changeEmailFromEmailConfirmToken(request: ChangeEmailRequestFromTokenRequest, messageId?: string): Promise<ClientResponseOfConfirmEmailTokenResult> {
        let apiPathAndParams = '/api/b2c/my-bolia/profile/email-confirm';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfConfirmEmailTokenResult>(apiUrl, request, messageId);
    }
    profile(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfB2CMyBoliaProfileModel> {
        let apiPathAndParams = '/api/b2c/my-bolia/profile';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfB2CMyBoliaProfileModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/my-bolia/profile-' + cancellationContextKey : undefined);
    }
    updateProfile(updateRequest: B2CUpdateProfileRequest, messageId?: string): Promise<ClientResponseOfB2CMyBoliaProfileModel> {
        let apiPathAndParams = '/api/b2c/my-bolia/profile';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfB2CMyBoliaProfileModel>(apiUrl, updateRequest, messageId);
    }
    deleteProfile(messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/b2c/my-bolia/profile';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponse>(apiUrl, messageId);
    }
    updateProfileAddress(address: B2CMyBoliaProfileAddress, messageId?: string): Promise<ClientResponseOfB2CMyBoliaProfileAddress> {
        let apiPathAndParams = '/api/b2c/my-bolia/profile/address';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfB2CMyBoliaProfileAddress>(apiUrl, address, messageId);
    }
    updateProfileFavoriteStore(request: B2CUpdateProfileFavoriteStoreRequest, messageId?: string): Promise<ClientResponseOfB2CMyBoliaProfileModel> {
        let apiPathAndParams = '/api/b2c/my-bolia/profile/favorite-store';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfB2CMyBoliaProfileModel>(apiUrl, request, messageId);
    }
    changeUserPassword(request: ChangePasswordRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/b2c/my-bolia/profile/password';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponse>(apiUrl, request, messageId);
    }
    resetPassword(request: ChangePasswordFromTokenRequest, messageId?: string): Promise<ClientResponseOfValidateTokenResult> {
        let apiPathAndParams = '/api/b2c/my-bolia/password/reset';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfValidateTokenResult>(apiUrl, request, messageId);
    }
    resetPasswordTokenByEmail(request: B2CResetPasswordTokenByUsernameRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/b2c/my-bolia/password/reset-token';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponse>(apiUrl, request, messageId);
    }
    validateResetToken(request: ValidateTokenRequest, messageId?: string): Promise<ClientResponseOfValidateTokenResult> {
        let apiPathAndParams = '/api/b2c/my-bolia/password/validate-token';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfValidateTokenResult>(apiUrl, request, messageId);
    }
    activateProfile(request: ActivateProfileRequest, messageId?: string): Promise<ClientResponseOfActivateProfileResponse> {
        let apiPathAndParams = '/api/b2c/my-bolia/profile/activate';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfActivateProfileResponse>(apiUrl, request, messageId);
    }
    createProfile(request: CreateProfileRequest, messageId?: string): Promise<ClientResponseOfCreateProfileResponse> {
        let apiPathAndParams = '/api/b2c/my-bolia/profile/create';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfCreateProfileResponse>(apiUrl, request, messageId);
    }
    resendRegistrationEmail(request: ResendRegistrationEmailRequest, messageId?: string): Promise<ClientResponseOfResendRegistrationEmailResponse> {
        let apiPathAndParams = '/api/b2c/my-bolia/profile/create/resendregistration';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfResendRegistrationEmailResponse>(apiUrl, request, messageId);
    }
    getOrders(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfOrderOverviewOf> {
        let apiPathAndParams = '/api/b2c/my-bolia/orders';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfOrderOverviewOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/my-bolia/orders-' + cancellationContextKey : undefined);
    }
    getOrder(orderNumber: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfOrder> {
        let apiPathAndParams = '/api/b2c/my-bolia/orders/order/{orderNumber}';
        if (orderNumber === undefined || orderNumber === null)
            throw new Error('The parameter "orderNumber" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{orderNumber}', encodeURIComponent('' + orderNumber));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfOrder>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/my-bolia/orders/order/{orderNumber}-' + cancellationContextKey : undefined);
    }
    getOrderConfirmationPdf(orderNumber: string | null | undefined, orderConfirmationId: string | null | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<FileResponse> {
        let apiPathAndParams = '/api/b2c/my-bolia/orders/orderconfirmation?';
        if (orderNumber !== undefined && orderNumber !== null)
            apiPathAndParams += 'orderNumber=' + encodeURIComponent('' + orderNumber) + '&';
        if (orderConfirmationId !== undefined && orderConfirmationId !== null)
            apiPathAndParams += 'orderConfirmationId=' + encodeURIComponent('' + orderConfirmationId) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<FileResponse>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/my-bolia/orders/orderconfirmation-' + cancellationContextKey : undefined);
    }
    getInvoicePdf(orderNumber: string | null | undefined, invoiceNumber: string | null | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<FileResponse> {
        let apiPathAndParams = '/api/b2c/my-bolia/orders/invoice?';
        if (orderNumber !== undefined && orderNumber !== null)
            apiPathAndParams += 'orderNumber=' + encodeURIComponent('' + orderNumber) + '&';
        if (invoiceNumber !== undefined && invoiceNumber !== null)
            apiPathAndParams += 'invoiceNumber=' + encodeURIComponent('' + invoiceNumber) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<FileResponse>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/my-bolia/orders/invoice-' + cancellationContextKey : undefined);
    }
    getDeliveryTimesForOrder(orderNumber: string | null, deliverySlotsForOrderQuery: B2CGetDeliverySlotsForOrderQuery, messageId?: string): Promise<ClientResponseOfB2CDeliverySlotsForOrderQueryResponse> {
        let apiPathAndParams = '/api/b2c/my-bolia/orders/delivery-times/get/{orderNumber}';
        if (orderNumber === undefined || orderNumber === null)
            throw new Error('The parameter "orderNumber" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{orderNumber}', encodeURIComponent('' + orderNumber));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfB2CDeliverySlotsForOrderQueryResponse>(apiUrl, deliverySlotsForOrderQuery, messageId);
    }
    setDeliveryTimeForOrder(orderNumber: string | null, deliverySlotsForOrderRequest: B2CSetDeliverySlotsForOrderRequest, messageId?: string): Promise<ClientResponseOfB2CSetDeliverySlotsForOrderResponse> {
        let apiPathAndParams = '/api/b2c/my-bolia/orders/delivery-times/set/{orderNumber}';
        if (orderNumber === undefined || orderNumber === null)
            throw new Error('The parameter "orderNumber" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{orderNumber}', encodeURIComponent('' + orderNumber));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfB2CSetDeliverySlotsForOrderResponse>(apiUrl, deliverySlotsForOrderRequest, messageId);
    }
    getMyBenefits(cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfMyBenefits> {
        let apiPathAndParams = '/api/b2c/my-bolia/my-benefits';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfMyBenefits>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/my-bolia/my-benefits-' + cancellationContextKey : undefined);
    }
    saveMyBenefits(request: SaveMyBenefitsRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/b2c/my-bolia/my-benefits';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponse>(apiUrl, request, messageId);
    }
    uploadClaimFormFile(file: FileParameter | null | undefined, messageId?: string): Promise<ClientResponseOfUploadClaimFormFileResponse> {
        let apiPathAndParams = '/api/b2c/my-bolia/claimform/upload-file';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfUploadClaimFormFileResponse>(apiUrl, messageId);
    }
    createClaim(request: CreateClaimsRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/b2c/my-bolia/claimform';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponse>(apiUrl, request, messageId);
    }
    getOrderReceiptByOrderNumber(orderNumber: string | null, basketId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfOrderReceiptModel> {
        let apiPathAndParams = '/api/b2c/order-receipt/{orderNumber}/{basketId}';
        if (orderNumber === undefined || orderNumber === null)
            throw new Error('The parameter "orderNumber" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{orderNumber}', encodeURIComponent('' + orderNumber));
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfOrderReceiptModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/order-receipt/{orderNumber}/{basketId}-' + cancellationContextKey : undefined);
    }
    initializePayment(basketId: string | null, messageId?: string): Promise<ClientResponseOfPaymentInitializeResult> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/payment';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfPaymentInitializeResult>(apiUrl, messageId);
    }
    submitOrderWithSufficientPaymentsInBasket(basketId: string | null, request: ProceedPaymentRequest, messageId?: string): Promise<ClientResponseOfPaymentFinalizeResult> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/payment/gift-card/submit-order-with-sufficient-payments';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfPaymentFinalizeResult>(apiUrl, request, messageId);
    }
    initializeAltaPayPayment(basketId: string | null, initializeAltaPayPaymentRequest: InitializeAltaPayPaymentRequest, messageId?: string): Promise<ClientResponseOfAltaPayPaymentInitializeResult> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/payment/alta-pay/initialize-payment';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfAltaPayPaymentInitializeResult>(apiUrl, initializeAltaPayPaymentRequest, messageId);
    }
    finalizeAltaPayPayment(basketId: string | null, finalizePaymentRequest: FinalizeAltaPayPaymentRequest, messageId?: string): Promise<ClientResponseOfPaymentFinalizeResult> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/payment/alta-pay/finalize-payment';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfPaymentFinalizeResult>(apiUrl, finalizePaymentRequest, messageId);
    }
    getBasketForCheckOut(basketId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfBasketCheckoutModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/check-out-' + cancellationContextKey : undefined);
    }
    addInvoiceAddress(basketId: string | null, invoiceAddressRequest: AddInvoiceAddressToBasketRequest, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/invoice-address';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketCheckoutModel>(apiUrl, invoiceAddressRequest, messageId);
    }
    setDeliveryAddress(basketId: string | null, deliveryId: number, deliveryAddress: BasketDeliveryAddress, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/delivery/{deliveryId}/delivery-address';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketCheckoutModel>(apiUrl, deliveryAddress, messageId);
    }
    setDeliveryTime(basketId: string | null, deliveryId: number, deliveryTimeRequest: SetDeliveryTimeRequest, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/delivery/{deliveryId}/delivery-time';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketCheckoutModel>(apiUrl, deliveryTimeRequest, messageId);
    }
    setCommentForHomeDelivery(basketId: string | null, deliveryId: number, setCommentRequest: SetCustomerDeliveryCommentRequest, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/delivery/{deliveryId}/set-comment';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketCheckoutModel>(apiUrl, setCommentRequest, messageId);
    }
    addDeliveryOption(basketId: string | null, deliveryId: number, itemId: string | null, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/delivery/{deliveryId}/delivery-option/{itemId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    removeDeliveryOption(basketId: string | null, deliveryId: number, itemId: string | null, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/delivery/{deliveryId}/delivery-option/{itemId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    changeClickAndCollectStoreFromCheckOut(basketId: string | null, storeId: string | null, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/change-click-and-collect-store/{storeId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (storeId === undefined || storeId === null)
            throw new Error('The parameter "storeId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{storeId}', encodeURIComponent('' + storeId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    splitDelivery(basketId: string | null, deliveryId: number, itemIds: number[], messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/delivery/{deliveryId}/split';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketCheckoutModel>(apiUrl, itemIds, messageId);
    }
    removeSplitDelivery(basketId: string | null, deliveryId: number, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/delivery/{deliveryId}/split';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    removeSplitDeliveries(basketId: string | null, deliveryId: number, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/delivery/{deliveryId}/remove-split';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    addGiftCardPayment(basketId: string | null, request: AddRedeemCodeRequest, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/add-gift-card-payment';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketCheckoutModel>(apiUrl, request, messageId);
    }
    removeGiftCardPaymentFromCheckOut(basketId: string | null, giftCardNumber: string | null, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/remove-gift-card-payment/{giftCardNumber}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (giftCardNumber === undefined || giftCardNumber === null)
            throw new Error('The parameter "giftCardNumber" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{giftCardNumber}', encodeURIComponent('' + giftCardNumber));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    getNearestParcelShopsForDelivery(basketId: string | null, deliveryId: number, amount: number | null | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfParcelShopModelOf> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/delivery/{deliveryId}/parcel-shops?';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        if (amount !== undefined && amount !== null)
            apiPathAndParams += 'amount=' + encodeURIComponent('' + amount) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfParcelShopModelOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/check-out/delivery/{deliveryId}/parcel-shops-' + cancellationContextKey : undefined);
    }
    getParcelShopsForZipCode(postalCode: string | null, basketId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfParcelShopModelOf> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/parcel-shops/{postalCode}';
        if (postalCode === undefined || postalCode === null)
            throw new Error('The parameter "postalCode" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{postalCode}', encodeURIComponent('' + postalCode));
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfParcelShopModelOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/check-out/parcel-shops/{postalCode}-' + cancellationContextKey : undefined);
    }
    setPickAndPackToParcelShopDelivery(basketId: string | null, parcelShop: ParcelShopModel, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/SetPickAndPackToParcelShopDelivery';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketCheckoutModel>(apiUrl, parcelShop, messageId);
    }
    setPickAndPackToHomeDelivery(basketId: string | null, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/check-out/SetPickAndPackToHomeDelivery';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    getBasket(basketId: string | null, basketMode: GetBasketMode | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}?';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (basketMode === null)
            throw new Error('The parameter "basketMode" cannot be null.');
        else if (basketMode !== undefined)
            apiPathAndParams += 'basketMode=' + encodeURIComponent('' + basketMode) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfBasketModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}-' + cancellationContextKey : undefined);
    }
    deleteBasket(basketId: string | null, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    addRegularItem(basketId: string | null, request: AddBasketItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/regular';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addPickAndPackItem(basketId: string | null, request: AddBasketItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/pick-and-pack';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addClickAndCollectItem(basketId: string | null, request: AddClickAndCollectBasketItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/click-and-collect';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addOutletItem(basketId: string | null, request: AddOutletItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/outlet';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addGiftCardItem(basketId: string | null, request: AddGiftCardItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/gift-card';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addModuleSofaItem(basketId: string | null, request: AddModuleSofaRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/module-sofa';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    updateModuleSofaItem(basketId: string | null, moduleSofaReferenceId: string, request: AddModuleSofaRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/module-sofa/{moduleSofaReferenceId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (moduleSofaReferenceId === undefined || moduleSofaReferenceId === null)
            throw new Error('The parameter "moduleSofaReferenceId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{moduleSofaReferenceId}', encodeURIComponent('' + moduleSofaReferenceId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    getModuleSofaItem(basketId: string | null, moduleSofaReferenceId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfModuleSofaConfigurationProductItem> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/module-sofa/{moduleSofaReferenceId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (moduleSofaReferenceId === undefined || moduleSofaReferenceId === null)
            throw new Error('The parameter "moduleSofaReferenceId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{moduleSofaReferenceId}', encodeURIComponent('' + moduleSofaReferenceId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfModuleSofaConfigurationProductItem>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/module-sofa/{moduleSofaReferenceId}-' + cancellationContextKey : undefined);
    }
    addOrUpdateModuleConfiguration(basketId: string | null, moduleConfigurationId: string, request: AddOrUpdateModuleConfigurationRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/module-configuration/{moduleConfigurationId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (moduleConfigurationId === undefined || moduleConfigurationId === null)
            throw new Error('The parameter "moduleConfigurationId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{moduleConfigurationId}', encodeURIComponent('' + moduleConfigurationId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    updateItemQuantity(basketId: string | null, itemId: number, request: UpdateItemQuantityRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/{itemId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    deleteItem(basketId: string | null, itemId: number, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/{itemId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    redeemCode(basketId: string | null, request: AddRedeemCodeRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/redeem-code';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    removePromoCode(basketId: string | null, promoCode: string | null, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/promo-code/{promoCode}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (promoCode === undefined || promoCode === null)
            throw new Error('The parameter "promoCode" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{promoCode}', encodeURIComponent('' + promoCode));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    changeToClickAndCollect(basketId: string | null, request: ChangeToClickAndCollectRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/change-to-click-and-collect';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    changeClickAndCollectStore(basketId: string | null, storeId: string | null, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/change-click-and-collect-store/{storeId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (storeId === undefined || storeId === null)
            throw new Error('The parameter "storeId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{storeId}', encodeURIComponent('' + storeId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    changeToPickAndPack(basketId: string | null, request: ChangeToPickAndRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/change-to-pick-and-pck';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    getUpSellProducts(basketId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfListOfUpSellProductItemRelation> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/up-sell';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfListOfUpSellProductItemRelation>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/up-sell-' + cancellationContextKey : undefined);
    }
    replaceItem(basketId: string | null, request: ReplaceItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/replace';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addGiftPackingToItem(basketId: string | null, itemId: number, request: AddGiftPackagingRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/{itemId}/gift-packaging';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    removeGiftPackingFromItem(basketId: string | null, itemId: number, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/{itemId}/gift-packaging';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    getBasketInvoiceAddress(basketId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfBasketInvoiceAddress> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/invoice-address';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfBasketInvoiceAddress>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/invoice-address-' + cancellationContextKey : undefined);
    }
    removeGiftCardPaymentFromBasket(basketId: string | null, giftCardNumber: string | null, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/remove-gift-card-payment/{giftCardNumber}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (giftCardNumber === undefined || giftCardNumber === null)
            throw new Error('The parameter "giftCardNumber" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{giftCardNumber}', encodeURIComponent('' + giftCardNumber));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    addCustomerOfferItemToBasket(basketId: string | null, customerOfferId: string | null, customerOfferLineItemIds: string[], messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/customer-offer/{customerOfferId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (customerOfferId === undefined || customerOfferId === null)
            throw new Error('The parameter "customerOfferId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{customerOfferId}', encodeURIComponent('' + customerOfferId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, customerOfferLineItemIds, messageId);
    }
    getEarliestDeliverDateForBasket(basketId: string | null, postalCode: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfEarliestCustomerDeliveryDateAndFreightPriceForBasketResult> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/delivery/earliest-delivery-date/{postalCode}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (postalCode === undefined || postalCode === null)
            throw new Error('The parameter "postalCode" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{postalCode}', encodeURIComponent('' + postalCode));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfEarliestCustomerDeliveryDateAndFreightPriceForBasketResult>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/delivery/earliest-delivery-date/{postalCode}-' + cancellationContextKey : undefined);
    }
    getEarliestDeliveryDateForCustomerDelivery(basketId: string | null, deliveryId: number, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfEarliestCustomerDeliveryDates> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/delivery/{deliveryId}/earliest-delivery-date';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfEarliestCustomerDeliveryDates>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/delivery/{deliveryId}/earliest-delivery-date-' + cancellationContextKey : undefined);
    }
    getDeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery(basketId: string | null, deliveryId: number, itemIds: number[], messageId?: string): Promise<ClientResponseOfDeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/delivery/{deliveryId}/split/earliest-delivery-date';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfDeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery>(apiUrl, itemIds, messageId);
    }
    getDeliveryTimesForCustomerDelivery(basketId: string | null, deliveryId: number, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfDeliveryTimesForCustomerDelivery> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/delivery/{deliveryId}/delivery-times/shipping';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfDeliveryTimesForCustomerDelivery>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/delivery/{deliveryId}/delivery-times/shipping-' + cancellationContextKey : undefined);
    }
    getPickUpPointsForDelivery(basketId: string | null, deliveryId: number, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfPickUpPointsForDelivery> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/delivery/{deliveryId}/pickup-points';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPickUpPointsForDelivery>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/delivery/{deliveryId}/pickup-points-' + cancellationContextKey : undefined);
    }
    getPickUpTimesForCustomerDelivery(basketId: string | null, deliveryId: number, hubId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfPickUpTimesForCustomerDelivery> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/delivery/{deliveryId}/delivery-times/pickup/{hubId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        if (hubId === undefined || hubId === null)
            throw new Error('The parameter "hubId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{hubId}', encodeURIComponent('' + hubId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPickUpTimesForCustomerDelivery>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/delivery/{deliveryId}/delivery-times/pickup/{hubId}-' + cancellationContextKey : undefined);
    }
    getEarliestHubPickUpDateForBasket(basketId: string | null, hubId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfEarliestHubPickUpdateDateForBasketResult> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/delivery/earliest-pickup-date/{hubId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (hubId === undefined || hubId === null)
            throw new Error('The parameter "hubId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{hubId}', encodeURIComponent('' + hubId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfEarliestHubPickUpdateDateForBasketResult>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/delivery/earliest-pickup-date/{hubId}-' + cancellationContextKey : undefined);
    }
    getDeliveryOptions(countryCode: string | null, basketId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfDeliveryOptionModelOf> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/delivery/delivery-options/customer-delivery/{countryCode}';
        if (countryCode === undefined || countryCode === null)
            throw new Error('The parameter "countryCode" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{countryCode}', encodeURIComponent('' + countryCode));
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfDeliveryOptionModelOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/delivery/delivery-options/customer-delivery/{countryCode}-' + cancellationContextKey : undefined);
    }
    getDeliveryOptionsForClickAndCollect(basketId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfDeliveryOptionModelOf> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/delivery/delivery-options/click-and-collect';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfDeliveryOptionModelOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/basket/{basketId}/delivery/delivery-options/click-and-collect-' + cancellationContextKey : undefined);
    }
    getClickAndCollectStoreInventoryStatus(basketId: string | null, itemIds: number[], messageId?: string): Promise<ClientResponseOfClickAndCollectStoreInventoryResultOf> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/inventory/click-and-collect-store-inventory';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfClickAndCollectStoreInventoryResultOf>(apiUrl, itemIds, messageId);
    }
    getPickAndPackInventoryStatus(basketId: string | null, itemIds: number[], messageId?: string): Promise<ClientResponseOfPickAndPackInventoryResultOf> {
        let apiPathAndParams = '/api/b2c/basket/{basketId}/inventory/pick-and-pack-inventory';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfPickAndPackInventoryResultOf>(apiUrl, itemIds, messageId);
    }
    getById(termsId: number, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfTermsAndConditionsModel> {
        let apiPathAndParams = '/api/b2c/terms-and-conditions/{termsId}';
        if (termsId === undefined || termsId === null)
            throw new Error('The parameter "termsId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{termsId}', encodeURIComponent('' + termsId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfTermsAndConditionsModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/terms-and-conditions/{termsId}-' + cancellationContextKey : undefined);
    }
    plusCurrency(request: number[], messageId?: string): Promise<ClientResponseOfBoliaMoney> {
        let apiPathAndParams = '/api/b2c/calculator/plus-currency';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBoliaMoney>(apiUrl, request, messageId);
    }
    login(request: LoginRequest, messageId?: string): Promise<ClientResponseOfLoginResponse> {
        let apiPathAndParams = '/api/b2c/authenticate/login';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfLoginResponse>(apiUrl, request, messageId);
    }
    refreshToken(refreshToken: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfRefreshTokenResponse> {
        let apiPathAndParams = '/api/b2c/authenticate/refresh-token/{refreshToken}';
        if (refreshToken === undefined || refreshToken === null)
            throw new Error('The parameter "refreshToken" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{refreshToken}', encodeURIComponent('' + refreshToken));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfRefreshTokenResponse>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/b2c/authenticate/refresh-token/{refreshToken}-' + cancellationContextKey : undefined);
    }
    logout(messageId?: string): Promise<ClientResponseOfRefreshTokenResponse> {
        let apiPathAndParams = '/api/b2c/authenticate/logout';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfRefreshTokenResponse>(apiUrl, messageId);
    }
}

export const B2CClientService = new B2CClient();

export interface ClientResponse {
    messages: ClientMessage[];
}

export interface ClientMessage {
    labelKey: string | undefined;
    message: string;
    messageType: ClientMessageType;
}

export enum ClientMessageType {
    Error = 0,
    Warning = 1,
    Info = 2,
}

export interface CreateMyBoliaProfileRequest {
    email: string;
    firstName: string;
    lastName: string;
    birthday: Date;
    language: string;
}

export interface ClientResponseOfSpecialDeliveryResponse {
    model: SpecialDeliveryResponse | undefined;
    messages: ClientMessage[];
}

export interface SpecialDeliveryResponse {
    emailSent: boolean;
}

export interface SpecialDeliveryRequest {
    name: string;
    street: string;
    postalCode: string;
    city: string;
    country: string;
    phone: string;
    email: string;
    productInformation: string;
    specialDeliveryPreferences: string | undefined;
    recipientEmail: string;
    recaptchaResponse: string;
}

export interface ClaimableProduct {
    itemId: string;
    productName: string;
    sku: string;
    quantity: number;
    claimableType: ClaimableType;
    deliveryDate: Date | undefined;
}

export enum ClaimableType {
    Product = 0,
    Freight = 1,
}

export interface GetClaimableProductsByOrderNumberRequest {
    orderNumber: string;
    recaptchaResponse: string;
}

export interface CreatePublicClaimsRequest {
    queue: string;
    orderNumber: string;
    contactDetails: PublicContactDetails;
    claims: PublicClaimDetails[];
    recaptchaResponse: string;
}

export interface PublicContactDetails {
    companyName: string | undefined;
    firstName: string;
    lastName: string;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    country: string | undefined;
    phoneNumber: string | undefined;
    email: string;
}

export interface PublicClaimDetails {
    itemId: string | undefined;
    productName: string | undefined;
    productSku: string | undefined;
    issue: PublicClaimFormIssue;
    claimFileIds: string[];
    grouped: boolean;
    claimableType: ClaimableType;
}

export interface PublicClaimFormIssue {
    code: string;
    category: string;
    description: string | undefined;
}

export interface ClientResponseOfPublicUploadClaimFormFileResponse {
    model: PublicUploadClaimFormFileResponse | undefined;
    messages: ClientMessage[];
}

export interface PublicUploadClaimFormFileResponse {
    claimFormFileId: string;
}

export interface ClientResponseOfPersonalOfferOverviewModelOf {
    model: PersonalOfferOverviewModel[] | undefined;
    messages: ClientMessage[];
}

export interface PersonalOfferOverviewModel {
    id: string;
    storeId: string | undefined;
    created: Date;
    skus: VariantImageVersion[];
}

export interface VariantImageVersion {
    sku: string;
    imageVersion: number;
}

export interface ClientResponseOfPersonalOfferViewModel {
    model: PersonalOfferViewModel | undefined;
    messages: ClientMessage[];
}

export interface PersonalOfferViewModel {
    offerId: string;
    createdDate: Date;
    items: PersonalOfferBaseItemModel[];
    totalListPrice: string;
    totalPrice: BoliaMoney;
    totalDiscount: BoliaMoney | undefined;
    salesTax: string;
    earliestDiscountDate: Date | undefined;
    earliestDiscountDays: number | undefined;
    store: PersonalOfferStoreModel;
    totalEcoTax: string | undefined;
    memberPrice: MemberPriceModel | undefined;
    buyAndGetYPctDiscount: BuyAndGetYPctDiscountModel | undefined;
}

export interface PersonalOfferBaseItemModel {
    id: string;
    quantity: number;
    sku: string;
    price: PersonalOfferItemPrice;
    type: PersonalOfferItemType;
    discriminator: string;
}

export interface PersonalOfferItemPrice {
    listPrice: BoliaMoney | undefined;
    listPriceTotal: BoliaMoney | undefined;
    ecoTaxTotal: BoliaMoney | undefined;
    salesPriceTotal: BoliaMoney | undefined;
    memberSalesPriceTotal: BoliaMoney | undefined;
    discounts: PersonalOfferDiscount[] | undefined;
}

export interface BoliaMoney {
    rawAmount: number;
    amount: string;
    currency: string;
}

export interface PersonalOfferDiscount {
    percentage: number;
    discountTotal: string;
    type: PersonalOfferDiscountType;
    expiresInDays: number | undefined;
    discriminator: string;
}

export enum PersonalOfferDiscountType {
    Campaign = 2,
    PromoCode = 3,
    MyBoliaBoost = 4,
}

export interface PersonalOfferPromoCodeDiscount extends PersonalOfferDiscount {
    redeemCode: string;
}

export interface PersonalOfferCampaignDiscount extends PersonalOfferDiscount {
}

export interface PersonalOfferMyBoliaBoostDiscount extends PersonalOfferDiscount {
}

export enum PersonalOfferItemType {
    Regular = 1,
    ModuleSofa = 9,
}

export interface PersonalOfferRegularItemModel extends PersonalOfferBaseItemModel {
    variant: Variant;
}

export interface Variant {
    name: string;
    itemNumber: string;
    sku: string;
    quantityMultiplier: number;
    productLifeCycle: ProductLifeCycle;
    specifications: SpecificationAttribute[] | undefined;
    productInformation: ProductInformation;
    basketSpecifications: SpecificationAttribute[] | undefined;
    collis: Colli[] | undefined;
    isWithinRequestedAssortment: boolean;
    imageVersion: number;
    ean: string | undefined;
    familyName: string | undefined;
    designerName: string | undefined;
    retailHierarchy: string | undefined;
    businessArea: string | undefined;
    isDiscontinued: boolean;
}

export enum ProductLifeCycle {
    Unknown = "Unknown",
    Created = "Created",
    PreReleased = "PreReleased",
    Released = "Released",
    Outgoing = "Outgoing",
    Discontinued = "Discontinued",
    Closed = "Closed",
    Construction = "Construction",
    OutletOnly = "OutletOnly",
    OutgoingCons = "OutgoingCons",
    B2BOnly = "B2BOnly",
}

export interface SpecificationAttribute {
    name: string;
    label: string;
    value: string;
}

export interface ProductInformation {
    ean: string | undefined;
    listItems: ProductVariantsSpecificationAttributes | undefined;
    assemblyGuideUrl: string | undefined;
    careGuideUrl: string | undefined;
    lightingUrl: string | undefined;
    userManualUrl: string | undefined;
    productFactSheetTemplate: string | undefined;
    warningUrl: string | undefined;
}

export interface ProductVariantsSpecificationAttributes {
    variantSpecifications: SpecificationAttribute[] | undefined;
    productLocalizedSpecifications: SpecificationAttribute[] | undefined;
}

export interface Colli {
    id: string;
    number: number;
    unitVolume: number;
    height: number;
    width: number;
    depth: number;
    grossWeight: number;
}

export interface PersonalOfferModuleSofaItemModel extends PersonalOfferBaseItemModel {
    title: string;
    image: string;
    modules: PersonalOfferRegularItemModel[];
}

export interface PersonalOfferStoreModel {
    storeId: string;
    employeeId: string | undefined;
    employeeName: string | undefined;
}

export interface MemberPriceModel {
    totalPrice: string;
    totalDiscount: string;
    salesTax: string;
}

export interface BuyAndGetYPctDiscountModel {
    label: LabelWithNamedArguments;
}

export interface LabelWithNamedArguments {
    label: string;
    severity: LabelSeverity;
    namedParams: { [key: string]: any; };
}

export enum LabelSeverity {
    Error = 0,
    Warning = 1,
    Information = 2,
}

export interface ClientResponseOfSubscribeToNewsletterResponse {
    model: SubscribeToNewsletterResponse | undefined;
    messages: ClientMessage[];
}

export interface SubscribeToNewsletterResponse {
    subscribtionSucceded: boolean;
}

export interface SubscribeToNewsletterRequest {
    name: string;
    email: string;
    storeId: string;
    storeName: string;
    countryCode: string;
    postalCode: string;
    recaptchaResponse: string;
}

export interface ClientResponseOfIEnumerableOfWishList {
    model: WishList[] | undefined;
    messages: ClientMessage[];
}

export interface WishList {
    id: number;
    userId: string;
    name: string;
    createDateTime: Date;
    skus: VariantImageVersion[];
    numberOfProducts: number;
    shareIdentifier: string;
    wishListItems: WishListItem[];
    purchasableProducts: string[];
}

export interface WishListItem {
    id: number;
    variant: Variant;
    price: ProductPriceModel;
    purchaseOptions: PurchaseOption[];
    isPurchasable: boolean;
}

export interface ProductPriceModel {
    listPrice: BoliaMoney;
    salesPrice: BoliaMoney;
    ecoTaxPrice: BoliaMoney | undefined;
    discount: ProductBaseDiscount | undefined;
    priceValidUntil: Date | undefined;
}

export interface ProductBaseDiscount {
    type: ProductDiscountType;
    discount: BoliaMoney;
    percentage: number;
    expiryLabel: LabelWithNamedArguments | undefined;
    discriminator: string;
}

export enum ProductDiscountType {
    Campaign = 0,
    MyBoliaBoost = 1,
}

export interface ProductCampaignDiscount extends ProductBaseDiscount {
}

export interface ProductMyBoliaBoostDiscount extends ProductBaseDiscount {
}

export interface PurchaseOption {
    type: PurchaseOptionType;
    sortOrder: number;
    quantityMultiplier: number;
    discriminator: string;
}

export enum PurchaseOptionType {
    Instant = 0,
    PickAndPack = 1,
    ClickAndCollect = 2,
    Standard = 3,
    Special = 4,
    B2BStandard = 5,
    InStoreOnly = 6,
    B2BExpress = 7,
    ModuleConfiguration = 8,
}

export interface StandardPurchaseOption extends PurchaseOption {
    title: string | undefined;
    description: string | undefined;
}

export interface InstantPurchaseOption extends PurchaseOption {
    title: string;
}

export interface PickAndPackPurchaseOption extends PurchaseOption {
    backOrderAvailable: boolean;
    title: string;
    description: string | undefined;
}

export interface ClickAndCollectPurchaseOption extends PurchaseOption {
    backOrderAvailable: boolean;
    title: string;
}

export interface SpecialDeliveryPurchaseOption extends PurchaseOption {
    findStoreAndDealersTitle: string;
    specialDeliveryTitle: string;
    specialDeliveryDescription: string;
}

export interface B2BStandardPurchaseOption extends PurchaseOption {
    title: string;
}

export interface InStoreOnlyPurchaseOption extends PurchaseOption {
    title: string;
    description: string | undefined;
}

export interface B2BExpressPurchaseOption extends PurchaseOption {
    title: string;
}

export interface ModuleConfigurationPurchaseOption extends PurchaseOption {
    title: string | undefined;
}

export interface ClientResponseOfWishList {
    model: WishList | undefined;
    messages: ClientMessage[];
}

export interface CreateWishListItemRequest {
    sku: string;
}

export interface CreateWishListRequest {
    name: string;
}

export interface UpdateWishListRequest {
    name: string;
}

export interface ClientResponseOfConfirmEmailTokenResult {
    model: ConfirmEmailTokenResult | undefined;
    messages: ClientMessage[];
}

export interface ConfirmEmailTokenResult {
    result: ConfirmEmailTokenResultType;
    email: string | undefined;
}

export enum ConfirmEmailTokenResultType {
    InvalidToken = 0,
    NoConfirmTokenForUser = 1,
    TokenExpired = 2,
    AnotherUserWithUnConfirmedEmailExists = 3,
    Success = 4,
    UserDoesNotExist = 5,
}

export interface ChangeEmailRequestFromTokenRequest {
    confirmEmailToken: string;
}

export interface ClientResponseOfB2CMyBoliaProfileModel {
    model: B2CMyBoliaProfileModel | undefined;
    messages: ClientMessage[];
}

export interface B2CMyBoliaProfileModel {
    email: string;
    firstName: string | undefined;
    lastName: string | undefined;
    storeId: string | undefined;
    address: B2CMyBoliaProfileAddress | undefined;
    unconfirmedEmail: string | undefined;
    birthday: Date | undefined;
}

export interface CustomerAddress {
    addressId: string | undefined;
    addressDescription: string | undefined;
    addressType: string | undefined;
    street: string | undefined;
    street2: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    country: string | undefined;
    mainAddress: boolean;
}

export interface B2CMyBoliaProfileAddress extends CustomerAddress {
    phone: string | undefined;
    alternativePhone: string | undefined;
}

export interface B2CUpdateProfileRequest {
    firstName: string;
    lastName: string;
    confirmEmailSettings: string;
    birthday: Date | undefined;
}

export interface ClientResponseOfB2CMyBoliaProfileAddress {
    model: B2CMyBoliaProfileAddress | undefined;
    messages: ClientMessage[];
}

export interface B2CUpdateProfileFavoriteStoreRequest {
    storeId: string;
}

export interface ChangePasswordRequest {
    password: string;
    newPassword: string;
    passwordConfirmation: string;
}

export interface ClientResponseOfValidateTokenResult {
    model: ValidateTokenResult | undefined;
    messages: ClientMessage[];
}

export interface ValidateTokenResult {
    result: ValidateTokenResultType;
}

export enum ValidateTokenResultType {
    Ok = 0,
    InvalidToken = 1,
    UserDoesNotExist = 2,
    NoResetTokenForUser = 3,
    TokenExpired = 4,
}

export interface ChangePasswordFromTokenRequest {
    resetToken: string;
    password: string;
    passwordConfirmation: string;
}

export interface B2CResetPasswordTokenByUsernameRequest {
    userName: string;
    recaptchaResponse: string;
    requestSettings: string;
}

export interface ValidateTokenRequest {
    resetToken: string;
}

export interface ClientResponseOfActivateProfileResponse {
    model: ActivateProfileResponse | undefined;
    messages: ClientMessage[];
}

export interface ActivateProfileResponse {
    activateProfileResultStatus: ActivateProfileResultStatusType;
}

export enum ActivateProfileResultStatusType {
    Ok = 0,
    InvalidToken = 1,
    ProfileRegistrationNotFound = 2,
    TokenExpired = 3,
    ProfileAlreadyRegistered = 4,
}

export interface ActivateProfileRequest {
    activationToken: string;
}

export interface ClientResponseOfCreateProfileResponse {
    model: CreateProfileResponse | undefined;
    messages: ClientMessage[];
}

export interface CreateProfileResponse {
    profileRegistrationId: string;
    status: CreateProfileStatus;
}

export enum CreateProfileStatus {
    Success = 0,
    ProfileWithThatUserNameAlreadyExist = 1,
}

export interface CreateProfileRequest {
    firstName: string;
    lastName: string;
    emailAddress: string;
    password: string;
    storeId: string | undefined;
    signUpNewsLetter: boolean;
    recaptchaResponse: string;
    birthday: Date | undefined;
    profileRegistrationSettings: string;
    zipCode: string | undefined;
}

export interface ClientResponseOfResendRegistrationEmailResponse {
    model: ResendRegistrationEmailResponse | undefined;
    messages: ClientMessage[];
}

export interface ResendRegistrationEmailResponse {
    status: ResendRegistrationEmailStatus;
}

export enum ResendRegistrationEmailStatus {
    Ok = 0,
    ProfileRegistrationNotFound = 1,
}

export interface ResendRegistrationEmailRequest {
    profileRegistrationId: string;
    profileRegistrationSettings: string;
}

export interface ClientResponseOfOrderOverviewOf {
    model: OrderOverview[] | undefined;
    messages: ClientMessage[];
}

export interface OrderOverview {
    orderNumber: string;
    orderDate: Date;
    salesStatus: SalesStatus;
    price: string;
    skus: VariantImageVersion[];
}

export enum SalesStatus {
    Open = 0,
    BackOrder = 1,
    Delivered = 2,
    Invoiced = 3,
    Cancelled = 4,
}

export interface ClientResponseOfOrder {
    model: Order | undefined;
    messages: ClientMessage[];
}

export interface Order {
    orderNumber: string;
    orderDate: Date;
    salesStatus: SalesStatus;
    customer: Customer;
    confirmationDocumentDownloadLink: string | undefined;
    deliverables: Deliverable[];
    serviceLines: ServiceLineItem[] | undefined;
    totalListPrice: string;
    subTotalPrice: string;
    totalPrice: string;
    totalDiscount: string | undefined;
    salesTax: string;
    invoices: Invoice[] | undefined;
    creditNotes: Invoice[] | undefined;
    ecoTaxTotal: string | undefined;
}

export interface Customer {
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    address: Address | undefined;
}

export interface Address {
    id: string;
    name: string | undefined;
    street: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    country: string | undefined;
}

export interface Deliverable {
    type: DeliverableType;
    address: Address | undefined;
    orderLines: BaseOrderLineItem[];
    confirmedDeliveryDateAndSlotFormatted: string | undefined;
    changedDeliveryDateSlotFormatted: string | undefined;
    trackAndTraceLinks: string[] | undefined;
    changeDeliveryDate: ChangeDeliveryDate;
}

export enum DeliverableType {
    CustomerDelivery = 0,
    PickUp = 1,
    PickAndPack = 2,
    ClickAndCollect = 3,
    Instant = 4,
}

export interface BaseOrderLineItem {
    id: string;
    itemId: string;
    description: string;
    quantity: number;
    salesHistory: SalesHistory;
    salesStatus: SalesStatus;
    price: OrderPriceModel;
    deliveryDate: Date | undefined;
    discriminator: string;
}

export enum SalesHistory {
    Normal = 0,
    Replaced = 2,
}

export interface OrderPriceModel {
    itemListPrice: string;
    totalPrice: string;
    discount: OrderDiscountModel | undefined;
}

export interface OrderDiscountModel {
    percentage: number;
    amount: string;
}

export interface ModuleSofaOrderLineItem extends BaseOrderLineItem {
    image: string | undefined;
    orderLineItems: OrderLineItem[];
}

export interface OrderLineItem extends BaseOrderLineItem {
    variant: Variant | undefined;
    isOutlet: boolean;
    isClaimable: boolean;
    claimableType: ClaimableType | undefined;
    isGift: boolean;
}

export interface GiftCardOrderLineItem extends BaseOrderLineItem {
    giftCardNumber: string | undefined;
}

export interface ChangeDeliveryDate {
    enabled: boolean;
    inventTransIds: string[] | undefined;
}

export interface ServiceLineItem {
    id: string;
    itemId: string;
    description: string;
    quantity: number;
    salesHistory: SalesHistory;
    salesStatus: SalesStatus;
    price: OrderPriceModel;
    deliveryDate: Date | undefined;
    imageVersion: number;
    isClaimable: boolean;
    claimableType: ClaimableType | undefined;
}

export interface Invoice {
    id: string;
    documentDownloadLink: string | undefined;
    amount: string;
}

export interface ClientResponseOfB2CDeliverySlotsForOrderQueryResponse {
    model: B2CDeliverySlotsForOrderQueryResponse | undefined;
    messages: ClientMessage[];
}

export interface B2CDeliverySlotsForOrderQueryResponse {
    deliverableType: DeliverableType;
    inventTransIds: string[];
    deliveryTimes: DeliveryTime[] | undefined;
    deliveryMessages: DeliveryMessage[] | undefined;
}

export interface DeliveryTime {
    id: string;
    startTime: Date;
    endTime: Date;
    modeOfDelivery: string | undefined;
    deliveryTimeId: number | undefined;
    deliveryDate: Date;
    deliverySlotFormatted: string;
}

export interface DeliveryMessage {
    inventSerialId: string | undefined;
    itemId: string | undefined;
    messageType: string | undefined;
}

export interface B2CGetDeliverySlotsForOrderQuery {
    inventTransIds: string[];
    deliverableType: DeliverableType;
    numberOfSlots: number;
}

export interface ClientResponseOfB2CSetDeliverySlotsForOrderResponse {
    model: B2CSetDeliverySlotsForOrderResponse | undefined;
    messages: ClientMessage[];
}

export interface B2CSetDeliverySlotsForOrderResponse {
}

export interface B2CSetDeliverySlotsForOrderRequest {
    inventTransIds: string[];
    deliverableType: DeliverableType;
    deliveryTimeId: number;
    startTime: Date;
    endTime: Date;
}

export interface ClientResponseOfMyBenefits {
    model: MyBenefits | undefined;
    messages: ClientMessage[];
}

export interface MyBenefits {
    stores: Store[];
    newsletterSubscription: SubscriptionStatus | undefined;
    canUpdatePreferences: boolean;
}

export interface Store {
    id: string;
    title: string;
    isSelected: boolean;
}

export enum SubscriptionStatus {
    None = 0,
    All = 1,
    Fewer = 2,
}

export interface SaveMyBenefitsRequest {
    storeId: string;
    newsletterSubscription: SubscriptionStatus;
}

export interface ClientResponseOfUploadClaimFormFileResponse {
    model: UploadClaimFormFileResponse | undefined;
    messages: ClientMessage[];
}

export interface UploadClaimFormFileResponse {
    claimFormFileId: string;
}

export interface CreateClaimsRequest {
    queue: string;
    orderNumber: string;
    contactDetails: ContactDetails;
    claims: ClaimDetails[];
}

export interface ContactDetails {
    firstName: string;
    lastName: string;
    address: string;
    postalCode: string;
    city: string;
    country: string;
    phoneNumber: string;
    email: string;
}

export interface ClaimDetails {
    itemId: string;
    productName: string;
    productSku: string;
    issue: ClaimFormIssue;
    claimFileIds: string[];
    grouped: boolean;
    claimableType: ClaimableType;
}

export interface ClaimFormIssue {
    code: string;
    category: string;
    description: string | undefined;
}

export interface ClientResponseOfOrderReceiptModel {
    model: OrderReceiptModel | undefined;
    messages: ClientMessage[];
}

export interface OrderReceiptModel {
    orderNumber: string;
    orderDate: string;
    invoiceAddress: OrderReceiptInvoiceAddress | undefined;
    deliverables: OrderReceiptDeliverable[];
    summary: OrderReceiptModelSummary;
    hasBeenRevenueTracked: boolean;
}

export interface OrderReceiptInvoiceAddress {
    buyer: BasketBuyer | undefined;
    address: BasketAddress | undefined;
    buyerContactInformation: BasketBuyerContactInformation | undefined;
}

export interface BasketBuyer {
    firstName: string;
    lastName: string;
    vatNumber: string | undefined;
    companyName: string | undefined;
}

export interface BasketAddress {
    street: string;
    street2: string | undefined;
    postalCode: string;
    unknownPostalCode: boolean;
    city: string;
    countryCode: string;
    country: string;
    otherCountryName: string | undefined;
    hasLift: boolean;
}

export interface BasketBuyerContactInformation {
    emailAddress: string;
    phoneNumber: string | undefined;
    alternateNumber: string | undefined;
}

export interface OrderReceiptDeliverable {
    type: OrderReceiptDeliverableType;
    deliveryDate: string | undefined;
    deliveryOptions: string[];
    deliveryType: OrderDeliveryType | undefined;
    deliveryAddress: OrderReceiptDeliveryAddress | undefined;
    items: OrderReceiptBaseItemModel[];
    discriminator: string;
}

export enum OrderReceiptDeliverableType {
    CustomerDelivery = 0,
    PickUp = 1,
    PickAndPack = 2,
    ClickAndCollect = 3,
    Instant = 4,
    Return = 5,
    GiftCertificate = 6,
}

export enum OrderDeliveryType {
    Shipping = 1,
    PickUp = 2,
    Manual = 99,
}

export interface OrderReceiptDeliveryAddress {
    locationName: string | undefined;
    buyer: BasketBuyer | undefined;
    address: BasketAddress;
}

export interface OrderReceiptBaseItemModel {
    id: number;
    name: string;
    quantity: number;
    quantityMultiplier: number;
    price: OrderReceiptItemPrice;
    discriminator: string;
}

export interface OrderReceiptItemPrice {
    listPrice: BoliaMoney | undefined;
    listPriceTotal: BoliaMoney | undefined;
    ecoTaxTotal: BoliaMoney | undefined;
    discounts: OrderReceiptDiscount[];
    salesPriceTotal: BoliaMoney | undefined;
}

export interface OrderReceiptDiscount {
    type: OrderReceiptDiscountType;
    percentage: number | undefined;
    discount: BoliaMoney;
    discountTotal: BoliaMoney;
}

export enum OrderReceiptDiscountType {
    Campaign = 2,
    PromoCode = 3,
    Store = 4,
    SoldToEmployee = 5,
    Outlet = 6,
    PreviousCampaign = 7,
    MyBoliaBoost = 8,
}

export interface OrderReceiptItemModel extends OrderReceiptBaseItemModel {
    sku: string;
    imageVersion: number;
    specifications: SpecificationAttribute[];
    hasGiftPacking: boolean;
    metaData: OrderProductMetaData | undefined;
    discriminator: string;
}

export interface OrderProductMetaData {
    family: string | undefined;
    retailHierarchy: string | undefined;
    businessArea: string | undefined;
    brand: string | undefined;
    ean: string | undefined;
}

export interface OrderReceiptOutletItemModel extends OrderReceiptItemModel {
    damageDescriptions: string[] | undefined;
}

export interface OrderReceiptModuleSofaItemModel extends OrderReceiptBaseItemModel {
    modules: OrderReceiptItemModel[];
    image: string;
}

export interface OrderReceiptModuleConfigurationItemModel extends OrderReceiptBaseItemModel {
    modules: OrderReceiptItemModel[];
    image: string;
}

export interface PickAndPackOrderReceiptDeliverable extends OrderReceiptDeliverable {
    parcelShop: OrderReceiptParcelShopModel;
}

export interface OrderReceiptParcelShopModel {
    companyName: string;
    street: string;
    street2: string | undefined;
    postalCode: string;
    city: string;
    countryCode: string;
    phoneNumber: string;
}

export interface OrderReceiptModelSummary {
    listPriceTotal: BoliaMoney;
    salesPriceSubTotal: BoliaMoney;
    discountTotal: BoliaMoney | undefined;
    freightPriceTotal: BoliaMoney | undefined;
    serviceOptions: OrderReceiptServiceOption[];
    deliveryOptions: OrderDeliveryOptionModel[];
    giftCards: OrderReceiptSummaryGiftCard[] | undefined;
    payments: OrderReceiptSummaryPayment[];
    appliedPromoCodes: PromoCodeModel[];
    salesPriceTotal: BoliaMoney;
    salesTax: BoliaMoney;
    ecoTaxTotal: BoliaMoney | undefined;
}

export interface OrderReceiptServiceOption {
    name: string;
    quantity: number;
    sku: string;
    description: string | undefined;
    price: BoliaMoney;
}

export interface OrderDeliveryOptionModel {
    itemId: string;
    name: string;
    description: string | undefined;
    price: BoliaMoney;
}

export interface OrderReceiptSummaryGiftCard {
    giftCertificateNumber: string;
    amountSpent: BoliaMoney;
    amountRemaining: BoliaMoney;
}

export interface OrderReceiptSummaryPayment {
    cardType: string;
    terminalName: string;
}

export interface PromoCodeModel {
    redeemCode: string;
    isActive: boolean;
}

export interface ClientResponseOfPaymentInitializeResult {
    model: PaymentInitializeResult | undefined;
    messages: ClientMessage[];
}

export interface PaymentInitializeResult {
    itemsOutOfStock: number[] | undefined;
    requiredEarliestDeliveryDate: Date | undefined;
}

export interface ClientResponseOfPaymentFinalizeResult {
    model: PaymentFinalizeResult | undefined;
    messages: ClientMessage[];
}

export interface PaymentFinalizeResult {
    orderNumber: string;
}

export interface ProceedPaymentRequest {
    subscribeNewsletter: boolean;
}

export interface ClientResponseOfAltaPayPaymentInitializeResult {
    model: AltaPayPaymentInitializeResult | undefined;
    messages: ClientMessage[];
}

export interface AltaPayPaymentInitializeResult {
    sessionId: string;
    token: string;
}

export interface InitializeAltaPayPaymentRequest {
    shopName: string | undefined;
}

export interface FinalizeAltaPayPaymentRequest {
    paymentId: string;
    orderNumber: string;
    subscribeNewsletter: boolean;
}

export interface ClientResponseOfBasketCheckoutModel {
    model: BasketCheckoutModel | undefined;
    messages: ClientMessage[];
}

export interface BasketCheckoutModel {
    basketId: string;
    invoiceAddressValidationRule: InvoiceAddressValidationRule;
    invoiceAddress: BasketInvoiceAddress | undefined;
    items: BaseProductItem[];
    summary: BasketCheckoutModelSummary;
    termsId: number;
    hasSufficientPayments: boolean;
    deliverables: CheckOutDeliverable[];
    allowB2BAddress: boolean;
}

export enum InvoiceAddressValidationRule {
    AllRequired = 0,
    NameAndEmailRequired = 1,
    NothingRequired = 2,
}

export interface BasketInvoiceAddress {
    buyer: BasketBuyer | undefined;
    address: BasketAddress | undefined;
    buyerContactInformation: BasketBuyerContactInformation | undefined;
    signUpNewsLetter: boolean;
}

export interface BaseItem {
    id: number;
    created: Date;
    lastModified: Date;
    uniqueIdentifier: string;
    primaryItemMessages: ItemMessage[];
    secondaryItemMessages: ItemMessage[];
    type: ItemType;
    discriminator: string;
}

export interface BaseProductItem extends BaseItem {
    sku: string;
    name: string;
    quantity: number;
    quantityMultiplier: number;
    isDiscontinued: boolean;
    isSoldOut: boolean;
    imageVersion: number;
    price: ProductItemPrice | undefined;
    specifications: SpecificationAttribute[] | undefined;
    clickAndCollectEnabled: boolean;
    pickAndPackEnabled: boolean;
    giftPackingOption: GiftPackingItemOption | undefined;
    metaData: ProductMetaData | undefined;
    discriminator: string;
}

export interface ProductItemPrice {
    listPrice: BoliaMoney | undefined;
    listPriceTotal: BoliaMoney | undefined;
    ecoTaxTotal: BoliaMoney | undefined;
    salesPriceTotal: BoliaMoney | undefined;
    discounts: BaseDiscount[] | undefined;
}

export interface BaseDiscount {
    type: DiscountType;
    percentage: number;
    discount: BoliaMoney;
    discountTotal: BoliaMoney;
    discriminator: string;
}

export enum DiscountType {
    Country = 1,
    Campaign = 2,
    PromoCode = 3,
    Store = 4,
    SoldToEmployee = 5,
    Outlet = 6,
    PreviousCampaign = 7,
    MyBoliaBoost = 8,
}

export interface CampaignDiscount extends BaseDiscount {
    offerId: string;
    offerName: string;
    yesterdaysCampaign: boolean;
}

export interface OutletDiscount extends BaseDiscount {
}

export interface StoreDiscountModel extends BaseDiscount {
    givenBy: string;
}

export interface PromoCodeDiscount extends BaseDiscount {
    redeemCode: string;
}

export interface MyBoliaBoostDiscountModel extends BaseDiscount {
    offerId: string;
    offerName: string;
}

export interface GiftPackingItemOption {
    price: BoliaMoney;
    totalPrice: BoliaMoney;
    quantity: number;
    description: string;
}

export interface ProductMetaData {
    family: string | undefined;
    retailHierarchy: string | undefined;
    businessArea: string | undefined;
    brand: string | undefined;
    ean: string | undefined;
}

export interface ItemMessage extends LabelWithNamedArguments {
    type: ItemMessageType;
}

export enum ItemMessageType {
    Default = 0,
    Basket = 1,
    CheckOut = 2,
}

export enum ItemType {
    Regular = 1,
    GiftCertificate = 4,
    Outlet = 5,
    ClickAndCollect = 7,
    PickAndPack = 8,
    ModuleSofa = 9,
    ModuleSofaItem = 12,
    ModuleConfiguration = 13,
    ModuleConfigurationItem = 14,
}

export interface RegularProductItem extends BaseProductItem {
}

export interface PickAndPackProductItem extends BaseProductItem {
    inventoryStatus: InventoryStatus | undefined;
    giftPackingMessage: GiftPackingMessage | undefined;
}

export interface InventoryStatus {
    totalAvailable: number;
    reservedByUser: number;
    remainingAvailable: number;
}

export interface GiftPackingMessage {
    from: string | undefined;
    to: string | undefined;
    message: string[] | undefined;
}

export interface ClickAndCollectProductItem extends BaseProductItem {
    inventoryStatus: InventoryStatus | undefined;
}

export interface OutletProductItem extends BaseProductItem {
    inventSerialId: string | undefined;
    damageDescriptions: string[] | undefined;
    recId: number | undefined;
    canBeDelivered: boolean;
    hub: string | undefined;
    isConsignment: boolean;
}

export interface ModuleSofaConfigurationProductItem extends BaseProductItem {
    modules: ModuleSofaProductItem[];
    modulesConnections: BasketModuleSofaItem[];
    specification: BasketModuleSofaSpecification | undefined;
    image: string | undefined;
    moduleReferenceId: string | undefined;
}

export interface ModuleSofaProductItem extends BaseProductItem {
}

export interface BasketModuleSofaItem {
    sku: string;
    connections: ModuleSofaConnection;
}

export interface ModuleSofaConnection {
    a: string;
    b: string;
    c: string;
    d: string;
}

export interface BasketModuleSofaSpecification {
    name: string;
    image: string;
    width: number;
    height: number;
}

export interface GiftCardProductItem extends BaseProductItem {
}

export interface ModuleConfigurationProductItem extends BaseProductItem {
    modules: ModuleProductItem[];
    image: string | undefined;
    moduleReferenceId: string | undefined;
    moduleConfigurationSpecification: ModuleConfigurationSpecification | undefined;
}

export interface ModuleProductItem extends BaseProductItem {
}

export interface ModuleConfigurationSpecification {
    depth: number;
    height: number;
    width: number;
}

export interface BasketModelBaseSummary {
}

export interface BasketCheckoutModelSummary extends BasketModelBaseSummary {
    listPriceTotal: BoliaMoney | undefined;
    discountTotal: BoliaMoney | undefined;
    salesPriceSubTotal: BoliaMoney | undefined;
    freightPriceTotal: BoliaMoney | undefined;
    salesTax: BoliaMoney | undefined;
    ecoTaxTotal: BoliaMoney | undefined;
    salesPriceTotal: BoliaMoney | undefined;
    totalPaid: BoliaMoney | undefined;
    remainingToBePaid: BoliaMoney | undefined;
    deliveryOptions: DeliveryOptionModel[] | undefined;
    appliedPromoCodes: PromoCodeModel[];
    serviceItemsTotals: ServiceOptionModel[];
    appliedGiftCardPayments: GiftCardPaymentModel[];
}

export interface DeliveryOptionModel {
    name: string;
    sku: string;
    description: string | undefined;
    price: BoliaMoney;
}

export interface ServiceOptionModel {
    name: string;
    quantity: number;
    sku: string;
    description: string | undefined;
    Price: BoliaMoney;
}

export interface GiftCardPaymentModel {
    giftCardNumber: string;
    remainingAmount: BoliaMoney;
}

export interface CheckOutDeliverable {
    id: number;
    type: CheckoutDeliverableType;
    itemIds: number[];
    isValid: boolean;
    discriminator: string;
}

export enum CheckoutDeliverableType {
    CustomerDelivery = 0,
    PickUp = 1,
    PickAndPack = 2,
    ClickAndCollect = 3,
    GiftCard = 4,
}

export interface CheckOutDeliverableWithAddress extends CheckOutDeliverable {
    deliveryAddress: BasketDeliveryAddress | undefined;
}

export interface BasketDeliveryAddress {
    address: BasketAddress | undefined;
    buyer: BasketBuyer | undefined;
}

export interface CustomerDeliveryCheckOutDeliverable extends CheckOutDeliverableWithAddress {
    deliveryType: DeliveryType | undefined;
    deliveryTimeId: number | undefined;
    selectedPickupPoint: string | undefined;
    freight: FreightModel | undefined;
    deliveryOptions: string[];
    generalTermsAndConditions: string | undefined;
    isPickupDisabled: boolean;
    comment: string | undefined;
}

export enum DeliveryType {
    Shipping = 1,
    PickUp = 2,
    Manual = 99,
}

export interface FreightModel {
    price: BoliaMoney | undefined;
    errorGettingPrice: boolean;
}

export interface PickUpCheckOutDeliverable extends CheckOutDeliverable {
    deliveryType: DeliveryType | undefined;
    deliveryTimeId: number | undefined;
    freight: FreightModel | undefined;
}

export interface ClickAndCollectCheckOutDeliverable extends CheckOutDeliverable {
    text: LabelWithNamedArguments;
    storeId: string | undefined;
    deliveryOptions: string[];
}

export interface PickAndPackCheckOutDeliverable extends CheckOutDeliverable {
    options: PickAndPackCheckOutDeliveryOption[];
    text: LabelWithNamedArguments;
}

export interface PickAndPackCheckOutDeliveryOption {
    sku: string;
    deliveryType: PickAndPackDeliveryType;
    price: BoliaMoney;
    isSelected: boolean;
    discriminator: string;
}

export enum PickAndPackDeliveryType {
    ParcelShop = 0,
    HomeDelivery = 1,
}

export interface PickAndPackParcelShopCheckOutDeliveryOption extends PickAndPackCheckOutDeliveryOption {
    parcelShop: ParcelShopModel | undefined;
}

export interface ParcelShopModel {
    idNumber: string;
    companyName: string;
    street: string;
    street2: string | undefined;
    postalCode: string;
    city: string;
    countryCode: string;
    telephone: string;
    longitude: string | undefined;
    latitude: string | undefined;
    metersToShop: number | undefined;
    openingHours: OpeningHour[] | undefined;
}

export interface OpeningHour {
    dayOfWeek: string | undefined;
    openFrom: string | undefined;
    openTo: string | undefined;
    breaks: Break[] | undefined;
}

export interface Break {
    from: string | undefined;
    to: string | undefined;
}

export interface PickAndPackHomeDeliveryCheckOutDeliveryOption extends PickAndPackCheckOutDeliveryOption {
    deliveryAddress: BasketDeliveryAddress | undefined;
}

export interface GiftCardCheckOutDeliverable extends CheckOutDeliverable {
}

export interface AddInvoiceAddressToBasketRequest {
    invoiceAddress: BasketInvoiceAddress;
}

export interface SetDeliveryTimeRequest {
    deliveryType: DeliveryType;
    requestedDeliveryType: DeliveryType | undefined;
    postalCode: string;
    inventoryLocationId: string | undefined;
    deliveryTime: BasketDeliveryTime | undefined;
}

export interface BasketDeliveryTime {
    deliveryTimeId: number;
    deliveryDate: Date;
    startTime: Date;
    endTime: Date;
    modeOfDelivery: string;
}

export interface SetCustomerDeliveryCommentRequest {
    comment: string | undefined;
}

export interface AddRedeemCodeRequest {
    redeemCode: string;
}

export interface ClientResponseOfParcelShopModelOf {
    model: ParcelShopModel[] | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfBasketModel {
    model: BasketModel | undefined;
    messages: ClientMessage[];
}

export interface BasketModel {
    basketId: string;
    retailChannelId: string;
    clickAndCollectStoreId: string | undefined;
    numberOfItems: number;
    deliverables: BasketDeliverable[];
    summary: BasketModelSummary;
    isCheckoutAble: boolean;
    hasSufficientPayments: boolean;
    created: Date;
    lastModified: Date;
    customerOfferId: string | undefined;
    upSellItemCounter: number;
    hasMyBoliaBoostCampaignDiscount: boolean;
}

export interface BasketDeliverable {
    type: CheckoutDeliverableType;
    items: BaseItem[];
    discriminator: string;
}

export interface BasketDeliverableForPickAndPack extends BasketDeliverable {
    changeToClickAndCollectEnabled: boolean;
    text: LabelWithNamedArguments;
}

export interface BasketDeliverableForClickAndCollect extends BasketDeliverable {
    storeId: string;
    changeToPickAndPackEnabled: boolean;
    text: LabelWithNamedArguments;
}

export interface BasketDeliverableForPickUp extends BasketDeliverable {
    hubId: string | undefined;
}

export interface BasketDeliverableForGiftCard extends BasketDeliverable {
}

export interface BasketModelSummary extends BasketModelBaseSummary {
    listPriceTotal: BoliaMoney | undefined;
    discountTotal: BoliaMoney | undefined;
    salesPriceSubTotal: BoliaMoney | undefined;
    freightPriceTotal: BoliaMoney | undefined;
    salesTax: BoliaMoney | undefined;
    ecoTaxTotal: BoliaMoney | undefined;
    salesPriceTotal: BoliaMoney | undefined;
    paidTotal: BoliaMoney | undefined;
    remainingToBePaid: BoliaMoney | undefined;
    appliedPromoCodes: PromoCodeModel[];
    serviceItemsTotals: ServiceOptionModel[];
    appliedGiftCardPayments: GiftCardPaymentModel[];
    buyAndGetYPctDiscount: BuyAndGetYPctDiscountModel | undefined;
}

export enum GetBasketMode {
    Default = 0,
    ForceBoost = 1,
}

export interface AddBasketItemRequest {
    sku: string;
    quantity: number;
    relatedItemId: number | undefined;
}

export interface AddClickAndCollectBasketItemRequest {
    sku: string;
    quantity: number;
    clickAndCollectStoreId: string;
    relatedItemId: number | undefined;
}

export interface AddOutletItemRequest {
    recId: number;
}

export interface AddGiftCardItemRequest {
    amount: number;
}

export interface AddModuleSofaRequest {
    specification: BasketModuleSofaSpecification;
    modules: BasketModuleSofaItem[];
}

export interface ClientResponseOfModuleSofaConfigurationProductItem {
    model: ModuleSofaConfigurationProductItem | undefined;
    messages: ClientMessage[];
}

export interface AddOrUpdateModuleConfigurationRequest {
    configuration: ModuleConfiguration;
    modules: ModuleConfigurationItem[];
}

export interface ModuleConfiguration {
    name: string;
    depth: number;
    height: number;
    width: number;
    image: string;
}

export interface ModuleConfigurationItem {
    sku: string;
    quantity: number;
}

export interface UpdateItemQuantityRequest {
    quantity: number;
    delta: boolean;
}

export interface ChangeToClickAndCollectRequest {
    clickAndCollectStoreId: string;
    itemIds: number[];
}

export interface ChangeToPickAndRequest {
    itemIds: number[];
}

export interface ClientResponseOfListOfUpSellProductItemRelation {
    model: UpSellProductItemRelation[] | undefined;
    messages: ClientMessage[];
}

export interface UpSellProductItemRelation {
    items: UpSellItemInBasket[];
    sku: string | undefined;
}

export interface UpSellItemInBasket {
    itemId: number;
    isInBasket: boolean;
}

export interface ReplaceItemRequest {
    lineItemId: string;
    targetSku: string;
}

export interface AddGiftPackagingRequest {
    from: string | undefined;
    to: string | undefined;
    message: string[] | undefined;
}

export interface ClientResponseOfBasketInvoiceAddress {
    model: BasketInvoiceAddress | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfEarliestCustomerDeliveryDateAndFreightPriceForBasketResult {
    model: EarliestCustomerDeliveryDateAndFreightPriceForBasketResult | undefined;
    messages: ClientMessage[];
}

export interface EarliestCustomerDeliveryDateAndFreightPriceForBasketResult {
    text: LabelWithNamedArguments;
    itemMessages: CustomerDeliveryItemMessage[] | undefined;
    freightPrice: BoliaMoney | undefined;
}

export interface CustomerDeliveryItemMessage {
    itemId: number;
    itemMessage: ItemMessage;
}

export interface ClientResponseOfEarliestCustomerDeliveryDates {
    model: EarliestCustomerDeliveryDates | undefined;
    messages: ClientMessage[];
}

export interface EarliestCustomerDeliveryDates {
    labelForItems: LabelForItem[] | undefined;
    generalLabel: LabelWithNamedArguments;
    canBeSplit: boolean;
    canRemoveSplit: boolean;
    shouldBeSplit: boolean;
    canBeDelivered: boolean;
    canUndoSplit: boolean;
}

export interface LabelForItem {
    itemId: number;
    label: LabelWithNamedArguments;
}

export interface ClientResponseOfDeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery {
    model: DeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery | undefined;
    messages: ClientMessage[];
}

export interface DeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery {
    text: LabelWithNamedArguments;
}

export interface ClientResponseOfDeliveryTimesForCustomerDelivery {
    model: DeliveryTimesForCustomerDelivery | undefined;
    messages: ClientMessage[];
}

export interface DeliveryTimesForCustomerDelivery {
    message: LabelWithNamedArguments | undefined;
    deliveryTimeSlotModel: DeliveryTimeSlotModel | undefined;
}

export interface DeliveryTimeSlotModel {
    deliveryType: DeliveryType;
    postalCode: string;
    inventoryLocationId: string;
    deliverySlots: DeliverySlot[] | undefined;
    requestedDeliveryType: DeliveryType | undefined;
}

export interface DeliverySlot {
    startTime: Date;
    endTime: Date;
    deliveryDate: Date;
    deliveryTimeId: number;
    modeOfDelivery: string;
    formattedDeliveryDate: string;
}

export interface ClientResponseOfPickUpPointsForDelivery {
    model: PickUpPointsForDelivery | undefined;
    messages: ClientMessage[];
}

export interface PickUpPointsForDelivery {
    defaultPickUpId: string | undefined;
    hubs: HubModel[];
}

export interface HubModel {
    id: string;
    name: string;
    street: string;
    zipCode: string;
    city: string;
    countryCode: string;
    countryName: string;
    latitude: number;
    longitude: number;
    isPickUpPoint: boolean;
}

export interface ClientResponseOfPickUpTimesForCustomerDelivery {
    model: PickUpTimesForCustomerDelivery | undefined;
    messages: ClientMessage[];
}

export interface PickUpTimesForCustomerDelivery {
    message: LabelWithNamedArguments | undefined;
    deliveryTimeSlotModel: DeliveryTimeSlotModel | undefined;
}

export interface ClientResponseOfEarliestHubPickUpdateDateForBasketResult {
    model: EarliestHubPickUpdateDateForBasketResult | undefined;
    messages: ClientMessage[];
}

export interface EarliestHubPickUpdateDateForBasketResult {
    text: LabelWithNamedArguments;
    itemMessages: PickDeliveryItemMessage[] | undefined;
}

export interface PickDeliveryItemMessage {
    itemId: number;
    itemMessage: ItemMessage;
}

export interface ClientResponseOfDeliveryOptionModelOf {
    model: DeliveryOptionModel[] | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfClickAndCollectStoreInventoryResultOf {
    model: ClickAndCollectStoreInventoryResult[] | undefined;
    messages: ClientMessage[];
}

export interface ClickAndCollectStoreInventoryResult {
    storeId: string;
    storeTitle: string;
    status: LabelWithNamedArguments;
    itemIdsAvailable: number[];
    itemIdsNotAvailable: number[];
}

export interface ClientResponseOfPickAndPackInventoryResultOf {
    model: PickAndPackInventoryResult[] | undefined;
    messages: ClientMessage[];
}

export interface PickAndPackInventoryResult {
    itemId: number;
    canBePickAndPackDelivered: boolean;
}

export interface ClientResponseOfTermsAndConditionsModel {
    model: TermsAndConditionsModel | undefined;
    messages: ClientMessage[];
}

export interface TermsAndConditionsModel {
    id: number;
    description: string;
}

export interface ClientResponseOfBoliaMoney {
    model: BoliaMoney | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfLoginResponse {
    model: LoginResponse | undefined;
    messages: ClientMessage[];
}

export interface LoginResponse {
    success: boolean;
    token: string;
    refreshToken: string;
}

export interface LoginRequest {
    userName: string;
    password: string;
    recaptchaResponse: string;
}

export interface ClientResponseOfRefreshTokenResponse {
    model: RefreshTokenResponse | undefined;
    messages: ClientMessage[];
}

export interface RefreshTokenResponse {
    success: boolean;
    token: string;
    refreshToken: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}